import { FORM_ACTIONS } from './formValidation'
import { get, getAll } from '@bigyouth/base'
import axios from 'axios'
import { ACTIONS as MODAL_ACTIONS } from './modal'
import { get as getPipe } from '../utils/sigpipe'
import scrollManager from '../utils/scrollManager'

export default {
  name: 'send-datas',

  componentDidMount () {
    const formId = this.el.getAttribute('data-form-id')

    if (formId) {
      this.pipe = getPipe(formId)

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          const formDataNew = new FormData()

          let birthday = []
          let object = ''

          for (const [key, value] of Object.entries(formData)) {
            if (!key.includes('birthday') && key !== 'passwordConfirm' && key !== 'contact[object1]' && key !== 'contact[object2]' && key !== 'contact[object3]') {
              formDataNew.append(key, value)
            } else if (key.includes('birthday')) {
              birthday = [value].concat(birthday)
            } else if (key === 'contact[object1]' || key === 'contact[object2]' || key === 'contact[object3]') {
              object = value !== '' ? value : object
            }
          }

          if (birthday !== '' && birthday.length > 0) {
            formDataNew.append('birthDate', birthday.join('/'))
          }

          // contact form
          if (object !== '') {
            formDataNew.append('contact[object]', object)
          }

          this.formData = formDataNew

          switch (action) {
            case FORM_ACTIONS.SUBMIT:
              if (get('[js-send-datas-error]')) {
                get('[js-send-datas-error]').remove()
              }

              if (this.props && this.props.hasLoader) {
                const loader = document.createElement('div')
                const submitButton = get('[js-send-datas-submit]')
                loader.classList.add('loader')
                submitButton.prepend(loader)
                submitButton.classList.add('is-loading')
              }

              // case for establishment (check name, then modals, then send datas)
              if (this.props && this.props.userType && this.props.userType === 'establishment' && (this.props.currentEstablishment === undefined || this.props.currentEstablishment !== formDataNew.get('companyName'))) {
                const companySIRET = new FormData()
                companySIRET.append('companySIRET', formData.companySIRET)

                axios.post(this.props.urlCheck, companySIRET, {})
                  .then(response => {
                    if (this.props.urlCheckNoModal && this.props.urlCheckNoModal === true && response.data.success) {
                      this.sendDatas(formDataNew)
                    } else {
                      const modal = response.data.success ? get('#confirm-establishment') : get('#error-establishment')

                      this.modalPipe = getPipe(modal.getAttribute('data-pipe-id'))
                      this.modalPipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })
                    }
                  })
                  .catch(e => {
                    console.log(e)
                  })
              } else {
                // case direct data sending with modal or go to url
                this.sendDatas(formDataNew)
              }
          }
        })
      }
    }

    this.btnConfirm = get('[js-send-datas-confirm]')

    if (this.btnConfirm && this.props.modal === '#confirm-establishment2') {
      this.btnConfirm.addEventListener('click', () => {
        this.sendDatas(this.formData)
      })
    }

    if (get('[js-send-datas-back]')) {
      get('[js-send-datas-back]').addEventListener('click', (e) => {
        e.preventDefault()

        // clear session
        axios.post('/session/clear')
          .then(response => {
            window.location = e.target.href
          })
          .catch(e => {
            console.log(e)
          })
      })
    }
  },

  sendDatas (datas) {
    axios.post(this.props.url, datas, {})
      .then(response => {
        this.stopLoader()

        if (response.data.success) {
          if (this.props.url === '/inscription' || this.props.url === '/inscription/establishment' || this.props.url === '/contact-form/submit') {
            // eslint-disable-next-line no-undef
            _paq.push(['trackEvent', 'Inscription compte', 'Formulaire ok'])
          }

          if (this.props.goTo) {
            if (this.props.clear) {
              // clear session
              axios.post('/session/clear')
                .then(response => {
                  localStorage.setItem('prevUrlCalled', this.props.url)
                  window.location.href = this.props.goTo
                })
                .catch(e => {
                  console.log(e)
                })
            } else {
              localStorage.setItem('prevUrlCalled', this.props.url)
              window.location.href = this.props.goTo
            }
          } else if (this.props.samePage) {
            const msg = document.createElement('p')
            msg.innerHTML = this.props.samePage
            msg.classList.add('success-message')

            if (this.el.closest('.modal__inner') !== null) {
              this.el.closest('.modal__inner').append(msg)
              msg.classList.add('success-message--modal')
            } else {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              })

              const el = get('.form__mandatory')
              el.parentNode.insertBefore(msg, el.nextElementSibling)
            }

            if (this.props.removeForm) {
              get('[js-send-datas-error-wrap]').remove()
              getAll('.page-contact__icon, .form__mandatory').forEach(el => {
                el.remove()
              })
            } else {
              setTimeout(() => {
                msg.remove()
              }, 5000)
            }
          } else if (this.props.closeModal) {
            const modal = get(this.props.closeModal)

            this.modalPipe = getPipe(modal.getAttribute('data-pipe-id'))
            this.modalPipe.write({ action: MODAL_ACTIONS.CLOSE, emitterEl: this.el })
          } else {
            const modal = get(this.props.modal)

            if (this.props.modal === '#confirm-indiv' || this.props.modal === '#confirm-establishment2') {
              get('[js-modal-mail]', modal).innerHTML = response.data.email
              get('[js-modal-mail]', modal).href = `mailto:${response.data.email}`
              get('[js-modal-input-mail]', modal).value = response.data.email
              modal.classList.add('not-clickable')
              get('[js-modal-close]', modal).classList.add('is-hidden')
            }

            this.modalPipe = getPipe(modal.getAttribute('data-pipe-id'))
            this.modalPipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })

            if (this.btnConfirm) {
              this.btnConfirm.closest('[js-modal]').classList.add('is-hidden')
            }
          }
        } else {
          // FormHelper::getErrorMessages() nests messages per field
          const flatten = v => v && typeof v === 'object' ? Object.values(v).flatMap(flatten) : [v]
          this.showError(flatten(response.data.errors || response.data.message).join(' '))
        }
      })
      .catch(e => {
        this.stopLoader()

        if (e.response) {
          this.showError(e.response.data.message)
        }

        if (this.props.url === '/inscription' || this.props.url === '/inscription/establishment' || this.props.url === '/contact-form/submit') {
          // eslint-disable-next-line no-undef
          _paq.push(['trackEvent', 'Inscription compte', 'Formulaire no ok'])
        }
      })
  },

  stopLoader () {
    if (this.props.hasLoader && get('.loader', this.el)) {
      get('.loader', this.el).remove()
      get('[js-send-datas-submit]').classList.remove('is-loading')
    }
  },

  showError (message) {
    const wrap = get('[js-send-datas-error-wrap]')

    if (!wrap) {
      return
    }

    const error = document.createElement('div')
    error.classList.add('form__error', 'text-right', '-mb-8')
    error.setAttribute('js-send-datas-error', '')
    error.textContent = `Erreur : ${message}`

    getAll('[js-modal]').forEach(modal => {
      modal.classList.add('is-hidden')
    })

    wrap.parentNode.insertBefore(error, wrap)

    scrollManager.restart()
  },
}
